import { Box, Typography } from '@mui/material';
import Link from '../Link';
import { PRODUCT_CATEGORY_ICONS } from '../../assets/icons/productCategoryIcons';

export default function ProductCategories({ categories, handleLinkClick }) {
  return (
    <>
      {categories.map((category) => (
        <Box key={category.id} mb="18px" display="flex" alignItems="center">
          <Box
            height={56}
            width={56}
            flexShrink={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            mr={2}
          >
            {PRODUCT_CATEGORY_ICONS[category.handle]}
          </Box>
          <Box display="flex" flexDirection="column" justifyContent="center">
            <Link href={category.link} onClick={handleLinkClick}>
              <Typography
                variant="h4"
                fontSize="1.125rem"
                component="span"
                color="blue.500"
                fontWeight={600}
              >
                {category.name}
              </Typography>
            </Link>
          </Box>
        </Box>
      ))}
    </>
  );
}
